"use client";

import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";

// Preferencia do dispositivo no cookie `estudio_tema` (claro|escuro), lida pelo script do layout raiz antes da
// pintura; sem cookie vale `prefers-color-scheme`. Nao e dado do cliente: nao grava AuditLog.
export function AlternadorTema() {
  const [escuro, setEscuro] = useState(false);

  useEffect(() => {
    setEscuro(document.documentElement.classList.contains("dark"));
  }, []);

  function alternar() {
    const proximo = !escuro;
    document.documentElement.classList.toggle("dark", proximo);
    document.cookie = `estudio_tema=${proximo ? "escuro" : "claro"}; path=/; max-age=31536000; samesite=lax`;
    setEscuro(proximo);
  }

  return (
    <Button type="button" size="sm" variant="ghost" data-testid="alternador-tema" aria-pressed={escuro} onClick={alternar}>
      Modo escuro
    </Button>
  );
}
